import { Card } from '@tribeplatform/react-ui-kit/Card';
export const CardContentBlock = Card.Content;
//# sourceMappingURL=Block.js.map